import { cn } from '@/lib/utils';
import { Ellipsis, Link2, Pin, PinOff, Trash2 } from 'lucide-react';

import { Pencil } from '@/components/icons/Pencil';
import { buttonVariants } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

import { Translator } from '../i18n';

interface Props {
  onDelete: () => void;
  onRename: () => void;
  onShare: () => void;
  onTogglePin: () => void;
  isPinned: boolean;
  className?: string;
}

export default function ThreadOptions({
  onDelete,
  onRename,
  onShare,
  onTogglePin,
  isPinned,
  className
}: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          id="thread-options"
          className={cn(
            buttonVariants({ variant: 'ghost', size: 'icon' }),
            'fongpt-hover-strong focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 text-muted-foreground',
            className
          )}
        >
          <Ellipsis />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-40" align="start" forceMount>
        <DropdownMenuItem
          id="pin-thread"
          onClick={(e) => {
            e.stopPropagation();
            onTogglePin();
          }}
        >
          <Translator
            path={
              isPinned
                ? 'threadHistory.thread.menu.unpin'
                : 'threadHistory.thread.menu.pin'
            }
          />
          {isPinned ? (
            <PinOff className="ml-auto" />
          ) : (
            <Pin className="ml-auto" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem
          id="share-thread"
          onClick={(e) => {
            // Same as rename/delete: sidebar row is a <Link>; stop navigation.
            e.stopPropagation();
            onShare();
          }}
        >
          <Translator path="threadHistory.thread.menu.share" />
          <Link2 className="ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem
          id="rename-thread"
          onClick={(e) => {
            e.stopPropagation();
            onRename();
          }}
        >
          <Translator path="threadHistory.thread.menu.rename" />
          <Pencil className="ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem
          id="delete-thread"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="text-red-500 focus:text-red-500"
        >
          <Translator path="threadHistory.thread.menu.delete" />
          <Trash2 className="ml-auto" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
